// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"Search_searchContainer__16Jdk","form":"Search_form__1ch7D","searchInput":"Search_searchInput__1W1ZZ"};